import { render, staticRenderFns } from "./dataRectification.vue?vue&type=template&id=677f8454&scoped=true"
import script from "./dataRectification.vue?vue&type=script&lang=js"
export * from "./dataRectification.vue?vue&type=script&lang=js"
import style0 from "./dataRectification.vue?vue&type=style&index=0&id=677f8454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f8454",
  null
  
)

export default component.exports